import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  Grid,
  Card,
  CardContent,
  Tooltip,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import * as Yup from 'yup';
import './styles.css';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';

import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import { TooltipInfo } from 'components/tooltips/tooltipsInfo';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import { labelField } from 'utils';

function Unity() {
  const location = useLocation();
  const [openProgress, setOpenProgress] = useState(false);
  const error = Error();
  const success = Success();
  const history = useHistory();
  const dispatch = useDispatch();
  let { id } = useParams();
  const classes = useStyles();
  const disable = useSelector((state) => state.disable.disable);

  useEffect(() => {
    if (location.state !== undefined) {
      id = location.state.id;
    }
  }, [location]);

  useEffect(() => {
    // carrega os dados no seu devido campo caso tenha id, do contrário,
    // carrega o formulário vazio para cadastrar um novo
    async function load() {
      if (id) {
        setOpenProgress(true);
        const unity_ = await api.get(`/unities/${id}`);
        formik.setValues(unity_.data);
        if (location.state !== undefined) {
          id = null;
          formik.setFieldValue('id', null);
        }
        setOpenProgress(false);
      }
    }
    load();
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    try {
      id
        ? await api.put(`/unities/${id}`, { ...data })
        : await api.post('/unities', { ...data });
      success();
      history.push('/unities');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      name: '',
      sigla: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().max(
        100,
        'Máximo de caracteres (100 caracteres).',
      ).required('Campo Obrigatório'),
      sigla: Yup.string().max(
        5,
        'Máximo de caracteres (5 caracteres).',
      ).required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      dispatch(setLoading(true));
      request(values);
    },
  });

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress && <Progress />}
      {' '}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {/** Carregamento circular para o carregamento dos dados */}
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados da Unidade de Medida
              {' '}
              <HtmlTooltip
                title={(
                  <>
                    Essa tela você consegue cadastrar as unidades de medidas que serão utilizadas no sistema.
                  </>
                )}
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>

            <CardContent style={{ padding: '0rem' }}>
              <FormGroup>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={8}>
                    <FormGroup>
                      <TextField
                        inputProps={{ maxLength: 101 }}
                        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                        id="name"
                        label={labelField('Nome')}
                        variant="outlined"
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={!!(formik.touched.name && formik.errors.name)}
                        helperText={
                          formik.touched.name
                          && formik.errors.name
                          && formik.errors.name
                        }
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormGroup>
                      <TextField
                        inputProps={{ maxLength: 6 }}
                        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                        id="sigla"
                        label={labelField('Sigla/Símbolo')}
                        variant="outlined"
                        sigla="sigla"
                        value={formik.values.sigla}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={!!(formik.touched.sigla && formik.errors.sigla)}
                        helperText={
                          formik.touched.sigla
                          && formik.errors.sigla
                          && formik.errors.sigla
                        }
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </FormGroup>
            </CardContent>
          </div>

          <GroupButton
            deleteRoute="/unities/"
            routeDelete="/unities"
            returnRoute="/unities"
            id={id}
            disable={disable}
            message="A exclusão dessa unidade de medida pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}

export default Unity;
